// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_nz-0";
export var animationContainer = "_nz-1";
export var itemPrice = "_nz-a";
export var itemizedContent = "_nz-9";
export var itemizedHeader = "_nz-7";
export var itemizedRow = "_nz-8";
export var itemizedSection = "_nz-6";
export var modalContent = "_nz-2";
export var orderName = "_nz-3";
export var refundOption = "_nz-4";
export var refundOptionsContainer = "_nz-5";
export var shippingLabel = "_nz-b";
export var totalRow = "_nz-c";